import React, { useState } from "react";

//user import

import { Route, Routes } from "react-router-dom";
import { Toolbar, Box, Grid, useTheme } from "@mui/material";
import Sidebar from "./components/Sidebar";
// import { adminroutes } from "../pages/Dashboard/routes";
import { mainroutes } from "../pages/routes";
import Topbar from "./Topbar";
import PrivateRoute, {
  RouteComponent,
} from "../Services/Routes/App/PrivateRouts";

function AdminPortal() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  // Theme

  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          position: "relative",
          backgroundColor: theme.palette.background.gradient,
        }}
      >
        <Sidebar
          handleDrawerToggle={handleDrawerToggle}
          mobileOpen={mobileOpen}
        />
        <Topbar handleDrawerToggle={handleDrawerToggle} />

        {/* <Toolbar /> */}

        <Box
          component="main"
          sx={{
            p: 3,
            width: { md: "78vw", sm: "98vw", xs: "98vw" },
          }}
        >
          {/* <Toolbar /> */}
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Routes>
                {mainroutes?.map((item, index) => (
                  <Route
                    key={`${index}-admin-routes-${item?.path}`}
                    //   caseSensitive={item?.exact}
                    path={item?.path}
                    element={<RouteComponent element={item?.component} />}
                  />
                ))}
              </Routes>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default AdminPortal;
